import { useQuery } from '@tanstack/react-query';
import getApi from '@/lib/axios';
import { ExtractFnReturnType } from '@/lib/react-query';
import { InadimplenciaHistoricalOverview } from '@/features/inadimplencia/types/InadimplenciaHistoricalOverview.ts';

async function getTermometroPedagogicoMetricasAlunos(params): Promise<InadimplenciaHistoricalOverview> {
  const api = await getApi();
  const { data } = await api.get<InadimplenciaHistoricalOverview>('/termometro/pedagogico/metricas_alunos/', {params});
  return data;
}

type QueryFnType = typeof getTermometroPedagogicoMetricasAlunos;

function useTermometroPedagogicoMetricasAlunos(params) {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['fetch-termometro-pedagogico-metrica-alunos',params ],
    queryFn: () =>  getTermometroPedagogicoMetricasAlunos(params),
  });
}

export { useTermometroPedagogicoMetricasAlunos };
